import type { TransmissaoFonte } from '@/shared/types';

interface TransmissaoFontePickerProps {
  fontes:           TransmissaoFonte[];
  fonteSelecionadaId: string | null;
  onSelecionar:     (fonteId: string) => void;
}

export default function TransmissaoFontePicker({
  fontes,
  fonteSelecionadaId,
  onSelecionar,
}: TransmissaoFontePickerProps) {
  const ativas = fontes.filter(f => f.ativo);

  if (ativas.length === 0) {
    return (
      <p className="text-xs text-slate-500 leading-relaxed">
        Nenhum transmissor cadastrado. Adicione CazéTV, GE TV etc. nas configurações da empresa.
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {ativas.map(fonte => {
        const selecionada = fonte.id === fonteSelecionadaId;
        return (
          <button
            key={fonte.id}
            type="button"
            onClick={() => onSelecionar(fonte.id)}
            className={`px-3 py-2 rounded-xl text-xs font-bold transition-all active:scale-95 ${
              selecionada
                ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/30 ring-1 ring-orange-400/40'
                : 'bg-white/[0.05] text-slate-400 ring-1 ring-white/[0.08] hover:text-slate-200'
            }`}
          >
            {fonte.nome}
          </button>
        );
      })}
    </div>
  );
}
